/*
 *   File : detail.js
 *   Author : https://evoqins.com
 *   Description : File to list all available documents in the selected customer's account. 
 *   Integrations : NA
 *   Version : 1.0.0
*/

// custom packages
import React, { Fragment, useEffect, useRef, useState } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { Modal } from 'bootstrap';

// custom components
import { Icon } from '../../Components/Icon';
import { CustomTab, EmptyScreen, OverLay } from '../../Components/Others';
import { SecondaryButton, TextButton } from '../../Components/Buttons';
import { ConfirmModal, PreviewModal, UnlinkAccountModal } from '../../Components/Modal';

// custom style
import style from "../../Style/Component/document.module.scss";
import { APIService } from '../../Service';
import { toast } from 'react-toastify';

const TAB_DATA = [
    { id: 1, label: 'Documents' },
    { id: 2, label: 'Action' },
];

const DocumentDetail = () => {

    const navigate = useNavigate();
    const { state } = useLocation();

    const { id } = useParams();
    const isRendered = useRef(true);
    const [toggleMenu, setToggleMenu] = useState(false);
    const [selectedTab, setSelectedTab] = useState(0);
    const [previewModal, setPreviewModal] = useState(false);
    const [unlinkModal, setUnlinkModal] = useState(false);

    const [blockConfirm, setBlockConfirm] = useState(false);
    const [blockStatus, setBlockStatus] = useState(false);

    const [confirm, setConfirm] = useState(false);
    const [status, setStatus] = useState(false);
    const [loader, setLoader] = useState(true);
    const [documentLoader, setDocumentLoader] = useState(true);
    const [viewDocument, setViewDocument] = useState({});
    const [documentAction, setDocumentAction] = useState({});
    const [shortName, setShortName] = useState("");

    const [documentData, setDocumentData] = useState(null);

    const [isCustomerBlocked, setIsCustomerBlocked] = useState(false);


    useEffect(() => {
        window.scrollTo({
            top: 0, behavior: 'smooth'
        });
    }, []);

    useEffect(() => {
        if (isRendered.current === true) {
            _viewDocument();
            _linkAndUnlink();
        }
        isRendered.current = false;
    }, [])

    useEffect(() => {
        if (state !== null) {
            setSelectedTab(state.tab_index);
        } else {
            setSelectedTab(1);
        }
    }, [state]);

    useEffect(() => {
        if (previewModal === true) {
            const preview_modal = new Modal(document.getElementById("preview-modal"));
            preview_modal.show();
        }
    }, [previewModal]);

    useEffect(() => {
        if (unlinkModal === true) {
            const open_modal = new Modal(document.getElementById('unlink-modal'));
            open_modal.show();
        }
    }, [unlinkModal]);

    useEffect(() => {
        if (confirm === true) {
            const confirm_modal = new Modal(document.getElementById('confirm-modal'));
            confirm_modal.show();
        }
    }, [confirm]);

    useEffect(() => {
        if (blockConfirm === true) {
            const confirm_modal = new Modal(document.getElementById('confirm-modal'));
            confirm_modal.show();
        }
    }, [blockConfirm]);


    useEffect(() => {
        _handleBackDrop();
        window.addEventListener('popstate', _handleBackDrop)
        return () => {
            window.removeEventListener('popstate', _handleBackDrop)
        }
    }, [])

    function _handleBackDrop() {
        setPreviewModal(false);
        if (document.querySelector('modal-backdrop')) {
            document.querySelector('.modal-backdrop').remove();
            document.body.style.overflow = 'unset';
        };
    };


    // handle toggle activate or deactivate 
    const _handleToggleMenu = () => {
        setToggleMenu(prev => !prev);
    };

    // handle tab change
    const _handleTab = (tab_id) => {
        navigate(`/documents/${id}`, {
            state: {
                tab_index: tab_id
            }
        });
    };

    // handle view document 
    const _handleView = (data) => {
        setPreviewModal(true);
        setDocumentData(data);
    };

    // handle download
    const _handleDownload = async (data) => {
        // console.log("data",data);

        const url = data;
        const response = await fetch(url);
        const blob = await response.blob();
        const a = document.createElement('a');
        a.href = URL.createObjectURL(blob);
        a.download = 'file'; // specify the file name
        a.click();
    };

    // handle unlink account 
    const _handleUnlink = () => {
        setUnlinkModal(true);
    };

    // handle data delete
    const _handleDataDelete = () => {
        setConfirm(true);
        setToggleMenu(false);
    };

    // handle block customer
    const _handleBlockCustomer = () => {
        setBlockConfirm(true);
        setToggleMenu(false);
    };


    // API - View document
    const _viewDocument = () => {
        let is_post = true;
        let url = 'document/view';
        let request = {
            "customer_id": id
        }
        APIService(is_post, url, request).then((response) => {
            if (response.status_code === 200) {

                let updated_name = response.data.customer_summary.customer_name.split(" ");
                let short_name;

                if (updated_name.length > 1) {
                    short_name = updated_name[0].substring(0, 1) + updated_name[1].substring(0, 1)
                } else {
                    short_name = updated_name[0].substring(0, 2)
                }

                setShortName(short_name.toUpperCase());

                setViewDocument(response.data);

                setIsCustomerBlocked(response.data.customer_summary.is_blocked);

            }
            else {
                setViewDocument({ data: [] });
                // toast.dismiss();
                // toast.error(response.message, { type: "error" });
            }
            setDocumentLoader(false);
        })
    };



    // API - Link and unlink
    const _linkAndUnlink = () => {
        let is_post = true;
        let url = 'document/action';
        let request = {
            "customer_id": id
        }
        APIService(is_post, url, request).then((response) => {
            if (response.status_code === 200) {
                setDocumentAction(response.data);
            } else {
                setDocumentAction({ data: [] });
                // toast.dismiss();
                // toast.error('Error linking/unlinking', { type: "error" });
            }
            setLoader(false);
        })

    };


    // API - Data delete
    const _deleteData = () => {
        let is_post = true;
        let url = 'document/delete';
        let request = {
            "customer_id": id
        }
        APIService(is_post, url, request).then((response) => {
            if (response.status_code === 200) {
                setStatus(true);
            } else {
                toast.dismiss();
                toast.error(response.message, { type: "error" });
            }
        })
    };


    // API - block customer
    const _blockCustomer = () => {
        let is_post = true;
        let url = 'user/block';
        let request = {
            "customer_id": id
        }
        APIService(is_post, url, request).then((response) => {
            if (response.status_code === 200) {
                setIsCustomerBlocked(response.data.is_blocked);
                setBlockStatus(true);
            } else {
                toast.dismiss();
                toast.success(response.message, { type: "error" });
            }
        })
    };

    return (
        <Fragment>
            {loader || documentLoader === true ?
                <div className='d-flex align-items-center justify-content-center min-vh-100'>
                    <img src={require("../../Assets/Image/loader.gif")}
                        draggable={false}
                        width={80}
                        height={80}
                        alt='loader'
                        className='text-center' />
                </div>
                :
                <section className='e-section-height pb-5' >
                    <div className='e-bg-lavender padding-52px-lr pt-2 padding-112px-bottom'>
                        <p className='mb-0 e-text-chinese-black e-primary-font e-font-16 e-font-weight-400 line-height-24px'>
                            <span className='text-decoration-hover-underline cursor-pointer'
                                onClick={() => navigate("/documents")}>Customers</span> / <span className='e-font-weight-600'>{documentAction.customer_summary.customer_name}
                            </span>
                        </p>
                    </div>

                    <div className='padding-52px-lr margin--80px-top'>
                        {/* Lead summary */}
                        <div className={`${style.e_summary_wrapper} e-bg-american-violet border-radius-16 padding-32px-tb px-4 position-relative`}>
                            <div className='d-flex gap-4 align-items-center'>
                                <div className='e-bg-blue-violet-light border-radius-64 p-4'>
                                    <p className='mb-0 e-text-cultured-light e-primary-font e-font-20 e-font-weight-400 line-height-20px'>
                                        {shortName}
                                    </p>
                                </div>

                                {/* Basic detail of admin  */}

                                <div className='d-flex align-items-center gap-3'>
                                    <div className='d-flex flex-column gap-12px'>
                                        <p className='mb-0 e-text-platinum e-primary-font e-font-14 e-font-weight-600 line-height-18px'>
                                            {documentAction.customer_summary.customer_name}
                                        </p>
                                        <a href={`mailto:${documentAction.customer_summary.customer_email}`} target='_blank' className='mb-0 d-flex e-text-platinum e-primary-font e-font-14 e-font-weight-600 line-height-18px text-decoration-none text-decoration-hover-underline'>
                                            {documentAction.customer_summary.customer_email}
                                        </a>
                                        <a href={`tel:${documentAction.customer_summary.customer_phone}`} className='d-flex e-text-platinum e-primary-font e-font-14 e-font-weight-600 line-height-18px text-decoration-none text-decoration-hover-underline'>
                                            {documentAction.customer_summary.customer_phone}
                                        </a>
                                    </div>
                                    <div className='vr e-bg-lavender-blue'></div>
                                    <div className='d-flex flex-column gap-12px'>
                                        <p className='mb-0 e-text-platinum e-primary-font e-font-14 e-font-weight-400 line-height-18px'>
                                            RM name: <span className='e-font-weight-600'>{documentAction.customer_summary.rm_name}</span>
                                        </p>
                                        <p className='mb-0 e-text-platinum e-primary-font e-font-14 e-font-weight-400 line-height-18px'>
                                            RM code: <span className='e-font-weight-600'>{documentAction.customer_summary.rm_code}</span>
                                        </p>
                                        <p className='mb-0 e-text-platinum e-primary-font e-font-14 e-font-weight-400 line-height-18px'>
                                            Global rebalance opt-out: <span className='e-font-weight-600'>{documentAction.customer_summary.global_rebalance_opt_out === false ? "No" : "Yes"}</span>
                                        </p>
                                    </div>
                                </div>

                            </div>

                            {/* Toggle menu  */}
                            <>
                                <Icon icon="menu"
                                    size="1.5rem"
                                    height="1.375rem"
                                    color="#FFFFFF"
                                    className="position-absolute right-32px top-16px cursor-pointer"
                                    onClick={_handleToggleMenu} />

                                {toggleMenu &&
                                    <>
                                        <OverLay isOpen={toggleMenu} onClose={_handleToggleMenu} />
                                        <div className={`${style.e_menu_popup} e-bg-white border-radius-8 position-absolute right-32px top-48px padding-10px-tb padding-12px-lr d-flex gap-20px flex-column z-index-99`}>
                                            <div className='d-flex gap-1 align-items-center cursor-pointer'
                                                onClick={_handleBlockCustomer}>
                                                <img src={require("../../Assets/Image/Others/deactivate.svg").default}
                                                    draggable={false}
                                                    alt='deactivate' />

                                                <p className='mb-0 e-text-raisin-black e-primary-font e-font-12 e-font-weight-600 line-height-16px'>
                                                    {isCustomerBlocked === true ? 'Unblock Customer' : 'Block Customer'}
                                                </p>
                                            </div>
                                            <div className='d-flex gap-1 align-items-center cursor-pointer'
                                                onClick={_handleDataDelete}>
                                                <img src={require("../../Assets/Image/Others/delete.svg").default}
                                                    draggable={false}
                                                    alt='delete' />

                                                <p className='mb-0 e-text-raisin-black e-primary-font e-font-12 e-font-weight-600 line-height-16px'>
                                                    Data Delete Request
                                                </p>
                                            </div>
                                        </div>
                                    </>
                                }
                            </>
                        </div>

                        {/* Custom tab */}
                        <div className='d-flex py-4 mt-2'>
                            <CustomTab data={TAB_DATA}
                                selectedTab={selectedTab}
                                tooltip={false}
                                handleClick={_handleTab} />
                        </div>

                        <div className={`${style.e_data_wrapper} e-bg-ghost-white border-radius-16 padding-32px-all min-vh-50`}>
                            {/* Documents */}
                            {selectedTab === 1 ?
                                <>
                                    {viewDocument.documents.pan !== null ?
                                        <>
                                            <h4 className='mb-4 e-text-smoky-black e-primary-font e-font-16 e-font-weight-600 line-height-20px'>
                                                Documents
                                            </h4>

                                            <div className='e-bg-magnolia p-3 border-radius-8 min-vh-50'>
                                                <div>
                                                    <div className='e-border-1px-bottom pb-3'>
                                                        <p className='mb-2 e-text-dark-silver e-primary-font e-font-14 e-font-weight-400 line-height-16px'>
                                                            PAN number
                                                        </p>
                                                        <p className='mb-4 e-text-chinese-black e-primary-font e-font-14 e-font-weight-600 line-height-20px'>
                                                            {viewDocument?.documents[0]?.pan ? viewDocument.documents[0].pan : '-'}
                                                        </p>

                                                        <p className='mb-2 e-text-dark-silver e-primary-font e-font-14 e-font-weight-400 line-height-16px'>
                                                            PAN uploaded
                                                        </p>
                                                        {viewDocument?.documents[0]?.pan_image !== null ? (
                                                            <>

                                                                {/* <img src={viewDocument.documents[0].pan_image}
                                                                    draggable={false}
                                                                    width={182}
                                                                    height={112}
                                                                    alt='document' /> */}
                                                                {(() => {
                                                                    const url = viewDocument.documents[0]?.pan_image;
                                                                    const isPDF =
                                                                        url.toLowerCase().includes('.pdf') ||
                                                                        url.split('?')[0].toLowerCase().endsWith('.pdf');

                                                                    return (
                                                                        <>
                                                                            {isPDF ? (
                                                                                <iframe
                                                                                    src={url}
                                                                                    width={282}
                                                                                    height={222}
                                                                                    className={style.e_document_wrapper}
                                                                                    title='Pan'
                                                                                />
                                                                            ) : (
                                                                                <img
                                                                                    src={url}
                                                                                    draggable={false}
                                                                                    width={182}
                                                                                    height={112}
                                                                                    className={style.e_document_wrapper}
                                                                                    alt='Pan'
                                                                                />
                                                                            )}

                                                                            <div className='d-flex align-items-center gap-32px pt-4 px-2'>
                                                                                <TextButton
                                                                                    name='View'
                                                                                    onClick={() => _handleView(url)}
                                                                                />
                                                                                {isPDF && (
                                                                                    <TextButton
                                                                                        name='Download'
                                                                                        onClick={() => _handleDownload(url)}
                                                                                    />
                                                                                )}
                                                                            </div>
                                                                        </>
                                                                    );
                                                                })()}
                                                            </>
                                                        ) : (
                                                            '-'
                                                        )}
                                                    </div>

                                                    <div className='e-border-1px-bottom py-3'>
                                                        <p className='mb-2 e-text-dark-silver e-primary-font e-font-14 e-font-weight-400 line-height-16px'>
                                                            Photo uploaded
                                                        </p>
                                                        {viewDocument?.documents[0]?.profile_image !== null ? (
                                                            <>
                                                                {(() => {
                                                                    const url = viewDocument.documents[0]?.profile_image;
                                                                    const isPDF =
                                                                        url?.toLowerCase().includes('.pdf') ||
                                                                        url.split('?')[0]?.toLowerCase().endsWith('.pdf');

                                                                    return (
                                                                        <>
                                                                            {isPDF ? (
                                                                                <iframe
                                                                                    src={url}
                                                                                    width={282}
                                                                                    height={222}
                                                                                    className={style.e_document_wrapper}
                                                                                    title='Profile'
                                                                                />
                                                                            ) : (
                                                                                <img
                                                                                    src={url}
                                                                                    draggable={false}
                                                                                    width={182}
                                                                                    height={112}
                                                                                    className={style.e_document_wrapper}
                                                                                    alt='Profile'
                                                                                />
                                                                            )}

                                                                            <div className='d-flex align-items-center gap-32px pt-4 px-2'>
                                                                                <TextButton
                                                                                    name='View'
                                                                                    onClick={() => _handleView(url)}
                                                                                />
                                                                                {isPDF && (
                                                                                    <TextButton
                                                                                        name='Download'
                                                                                        onClick={() => _handleDownload(url)}
                                                                                    />
                                                                                )}
                                                                            </div>
                                                                        </>
                                                                    );
                                                                })()}
                                                            </>
                                                        ) : (
                                                            '-'
                                                        )}
                                                    </div>

                                                    {/* Address proof */}
                                                    <div className='e-border-1px-bottom py-3 '>
                                                        <div className='d-flex gap-40px align-items-end'>
                                                            <div>
                                                                <p className='mb-2 e-text-dark-silver e-primary-font e-font-14 e-font-weight-400 line-height-16px'>
                                                                    Address proof
                                                                </p>

                                                                {viewDocument.documents[0]?.address_proof_url ?
                                                                    <div className='mt-1 pt-2'>
                                                                        {(() => {
                                                                            const url = viewDocument.documents[0]?.address_proof_url;
                                                                            const isPDF = url.toLowerCase().includes('.pdf') ||
                                                                                url.split('?')[0].toLowerCase().endsWith('.pdf')

                                                                            return (
                                                                                <>
                                                                                    {isPDF ? (
                                                                                        <iframe
                                                                                            src={url}
                                                                                            width={282}
                                                                                            height={222}
                                                                                            className={style.e_document_wrapper}
                                                                                            title='Address proof'
                                                                                        />
                                                                                    ) : (
                                                                                        <img
                                                                                            src={url}
                                                                                            draggable={false}
                                                                                            width={182}
                                                                                            height={112}
                                                                                            className={style.e_document_wrapper}
                                                                                            alt='Address proof'
                                                                                        />
                                                                                    )}


                                                                                    <div className='d-flex align-items-center gap-32px pt-3 px-2'>
                                                                                        <TextButton name="View"
                                                                                            onClick={() => _handleView(viewDocument.documents[0].address_proof_url)} />
                                                                                        {isPDF &&
                                                                                            <TextButton name="Download"
                                                                                                onClick={() => _handleDownload(viewDocument.documents[0].address_proof_url)} />
                                                                                        }
                                                                                    </div>
                                                                                </>
                                                                            )
                                                                        })()}

                                                                    </div>
                                                                    :
                                                                    "-"
                                                                }

                                                            </div>

                                                        </div>
                                                    </div>

                                                    {/* bank_proof */}
                                                    <div className='e-border-1px-bottom py-3 '>
                                                        <div className='d-flex gap-40px align-items-end'>
                                                            <div>
                                                                <p className='mb-2 e-text-dark-silver e-primary-font e-font-14 e-font-weight-400 line-height-16px'>
                                                                    Bank proof
                                                                </p>

                                                                {viewDocument.documents[0]?.bank_proof ? (
                                                                    <div className='mt-1 pt-2'>
                                                                        {(() => {
                                                                            const url = viewDocument.documents[0]?.bank_proof;
                                                                            const isPDF = url.toLowerCase().includes('.pdf') ||
                                                                                url.split('?')[0].toLowerCase().endsWith('.pdf')

                                                                            return (
                                                                                <>
                                                                                    {isPDF ? (
                                                                                        <iframe
                                                                                            src={url}
                                                                                            width={300}
                                                                                            height={222}
                                                                                            className={style.e_document_wrapper}
                                                                                            title='Bank proof'
                                                                                        />
                                                                                    ) : (
                                                                                        <img
                                                                                            src={url}
                                                                                            draggable={false}
                                                                                            width={182}
                                                                                            height={112}
                                                                                            className={style.e_document_wrapper}
                                                                                            alt='Bank proof'
                                                                                        />
                                                                                    )}

                                                                                    <div className='d-flex align-items-center gap-32px pt-3 px-2'>
                                                                                        <TextButton
                                                                                            name="View"
                                                                                            onClick={() => _handleView(viewDocument.documents[0].bank_proof)}
                                                                                        />
                                                                                        {isPDF &&
                                                                                            <TextButton
                                                                                                name="Download"
                                                                                                onClick={() => _handleDownload(viewDocument.documents[0].bank_proof)}
                                                                                            />
                                                                                        }
                                                                                    </div>
                                                                                </>
                                                                            )
                                                                        })()}


                                                                    </div>
                                                                ) : (
                                                                    "-"
                                                                )}
                                                            </div>
                                                        </div>
                                                    </div>


                                                    {/* identity_proof */}
                                                    <div className='e-border-1px-bottom py-3 '>
                                                        <div className='d-flex gap-40px align-items-end'>
                                                            <div>
                                                                <p className='mb-2 e-text-dark-silver e-primary-font e-font-14 e-font-weight-400 line-height-16px'>
                                                                    Identity proof
                                                                </p>

                                                                {viewDocument.documents[0]?.identity_proof ?
                                                                    <div className='mt-1 pt-2'>
                                                                        {(() => {
                                                                            const url = viewDocument.documents[0]?.identity_proof;
                                                                            const isPDF = url.toLowerCase().includes('.pdf') ||
                                                                                url.split('?')[0].toLowerCase().endsWith('.pdf')

                                                                            return (
                                                                                <>
                                                                                    {isPDF ? (
                                                                                        <iframe
                                                                                            src={url}
                                                                                            width={282}
                                                                                            height={222}
                                                                                            className={style.e_document_wrapper}
                                                                                            title='Identity proof'
                                                                                        />
                                                                                    ) : (
                                                                                        <img
                                                                                            src={url}
                                                                                            draggable={false}
                                                                                            width={182}
                                                                                            height={112}
                                                                                            className={style.e_document_wrapper}
                                                                                            alt='Identity proof'
                                                                                        />
                                                                                    )}

                                                                                    <div className='d-flex align-items-center gap-32px pt-3 px-2'>
                                                                                        <TextButton name="View"
                                                                                            onClick={() => _handleView(viewDocument.documents[0].identity_proof)} />
                                                                                        {isPDF &&
                                                                                            <TextButton name="Download"
                                                                                                onClick={() => _handleDownload(viewDocument.documents[0].identity_proof)} />
                                                                                        }
                                                                                    </div>
                                                                                </>
                                                                            )
                                                                        })()}


                                                                    </div>
                                                                    :
                                                                    "-"
                                                                }
                                                            </div>
                                                        </div>
                                                    </div>

                                                    {/* sign_proof */}
                                                    <div className='e-border-1px-bottom py-3 '>
                                                        <div className='d-flex gap-40px align-items-end'>
                                                            <div>
                                                                <p className='mb-2 e-text-dark-silver e-primary-font e-font-14 e-font-weight-400 line-height-16px'>
                                                                    Sign
                                                                </p>

                                                                {viewDocument.documents[0]?.sign_proof ?
                                                                    <div className='mt-1 pt-2'>
                                                                        {(() => {
                                                                            const url = viewDocument.documents[0]?.sign_proof;
                                                                            const isPDF = url.toLowerCase().includes('.pdf') ||
                                                                                url.split('?')[0].toLowerCase().endsWith('.pdf')

                                                                            return (
                                                                                <>
                                                                                    {isPDF ? (
                                                                                        <iframe
                                                                                            src={url}
                                                                                            width={282}
                                                                                            height={222}
                                                                                            className={style.e_document_wrapper}
                                                                                            title='Sign'
                                                                                        />
                                                                                    ) : (
                                                                                        <img
                                                                                            src={url}
                                                                                            draggable={false}
                                                                                            width={182}
                                                                                            height={112}
                                                                                            className={style.e_document_wrapper}
                                                                                            alt='Sign'
                                                                                        />
                                                                                    )}

                                                                                    <div className='d-flex align-items-center gap-32px pt-3 px-2'>
                                                                                        <TextButton name="View"
                                                                                            onClick={() => _handleView(viewDocument.documents[0].sign_proof)} />
                                                                                        {isPDF &&
                                                                                            <TextButton name="Download"
                                                                                                onClick={() => _handleDownload(viewDocument.documents[0].sign_proof)} />
                                                                                        }
                                                                                    </div>
                                                                                </>
                                                                            )
                                                                        })()}

                                                                    </div>
                                                                    :
                                                                    "-"
                                                                }
                                                            </div>
                                                        </div>
                                                    </div>

                                                    {/* passport_image */}
                                                    <div className='e-border-1px-bottom py-3 '>
                                                        <div className='d-flex gap-40px align-items-end'>
                                                            <div>
                                                                <p className='mb-2 e-text-dark-silver e-primary-font e-font-14 e-font-weight-400 line-height-16px'>
                                                                    Passport
                                                                </p>

                                                                {viewDocument.documents[0]?.passport_image ?
                                                                    <div className='mt-1 pt-2'>

                                                                        {(() => {
                                                                            const url = viewDocument.documents[0]?.passport_image;
                                                                            const isPDF = url.toLowerCase().includes('.pdf') ||
                                                                                url.split('?')[0].toLowerCase().endsWith('.pdf')

                                                                            return (
                                                                                <>
                                                                                    {isPDF ? (
                                                                                        <iframe
                                                                                            src={url}
                                                                                            width={282}
                                                                                            height={222}
                                                                                            className={style.e_document_wrapper}
                                                                                            title='passport'
                                                                                        />
                                                                                    ) : (
                                                                                        <img
                                                                                            src={url}
                                                                                            draggable={false}
                                                                                            width={182}
                                                                                            height={112}
                                                                                            className={style.e_document_wrapper}
                                                                                            alt='passport'
                                                                                        />
                                                                                    )}

                                                                                    <div className='d-flex align-items-center gap-32px pt-3 px-2'>
                                                                                        <TextButton name="View"
                                                                                            onClick={() => _handleView(viewDocument.documents[0].passport_image)} />
                                                                                        {isPDF &&
                                                                                            <TextButton name="Download"
                                                                                                onClick={() => _handleDownload(viewDocument.documents[0].passport_image)} />
                                                                                        }
                                                                                    </div>
                                                                                </>
                                                                            )
                                                                        })()}

                                                                    </div>
                                                                    :
                                                                    "-"
                                                                }
                                                            </div>
                                                        </div>
                                                    </div>

                                                </div>
                                            </div>
                                        </>
                                        :
                                        <EmptyScreen width={80}
                                            height={80}
                                            image={require('../../Assets/Image/NotFound/no-data.png')}
                                            title='No data found'

                                        />
                                    }
                                </>
                                :
                                // Action 
                                <div className='d-flex align-items-center gap-4'>
                                    <SecondaryButton name="Link/unlink account"
                                        paddingBlock="padding-12px-tb px-3"
                                        onClick={_handleUnlink} />
                                    <SecondaryButton name="Data Delete"
                                        paddingBlock="padding-12px-tb padding-36px-lr"
                                        onClick={_handleDataDelete} />
                                </div>
                            }
                        </div>
                    </div>
                </section>
                // :
                // <EmptyScreen
                //     image={require('../../Assets/Image/NotFound/no-data.png')}
                //     title='No results found'
                //     description={`We couldn' t find anything that matches your search. Try checking your spelling, using different keywords, or exploring popular funds.`}
                // />
            }

            {/* Document preview modal */}
            {previewModal === true &&
                <PreviewModal type={2}
                    title="View document"
                    data={documentData}
                    button={false}
                    handleClose={() => {
                        setTimeout(() => {
                            setPreviewModal(false);
                            setDocumentData(null);
                        }, 200);
                    }} />
            }

            {/* Unlink account modal */}
            {unlinkModal === true &&
                <UnlinkAccountModal
                    handleClose={() => {
                        setTimeout(() => {
                            setUnlinkModal(false);
                        }, 200);
                    }}
                    handleSuccess={() => {
                        navigate('/documents');
                        // _viewDocument();
                        setTimeout(() => {
                            setUnlinkModal(false);
                        }, 200);
                    }} />
            }

            {/* confirm block customer modal */}
            {blockConfirm === true &&
                <ConfirmModal title={blockStatus ? "Confirm successfully" : isCustomerBlocked === true ? "Unblock user confirmation" : "Block user confirmation"}
                    description={blockStatus ? isCustomerBlocked === true ? "The customer blocked successfully." : "The customer Unblocked successfully." : isCustomerBlocked === true ? "You are about Unblock this user. This action will grant them access. Are you sure want to proceed?" : "You are about block this user. This action will revoke their access. Are you sure want to proceed?"}
                    status={blockStatus}
                    handleClose={() => {
                        setTimeout(() => {
                            setBlockConfirm(false);
                            setBlockStatus(false);
                        }, 200);
                    }}
                    handleConfirm={() => {
                        _blockCustomer();
                    }
                    }
                    handleSuccess={() => {
                        setTimeout(() => {
                            setBlockConfirm(false);
                            setBlockStatus(false);
                            setToggleMenu(false);
                        }, 200);
                    }} />
            }


            {/* confirm delete data modal */}
            {confirm === true &&
                <ConfirmModal title={status ? "Confirm successfully" : "Confirm data delete request"}
                    description={status ? "The data deleted successfully." : " This action will initiate the data deletion process for this customer. Please ensure all documentation is reviewed and compliant with data policies before proceeding."}
                    status={status}
                    handleClose={() => {
                        setTimeout(() => {
                            setConfirm(false);
                            setStatus(false);
                        }, 200);
                    }}
                    handleConfirm={() => _deleteData()}
                    handleSuccess={() => {
                        navigate('/documents');
                        setTimeout(() => {
                            setConfirm(false);
                            setStatus(false);
                            setToggleMenu(false);
                        }, 200);
                    }} />
            }
        </Fragment>

    )
}

export default DocumentDetail;
